module.exports = __webpack_public_path__ + "static/media/wallet-connection.f10341fd.png";